import { prStatusPermissions } from "./permissionMap";

export function getPermission(status, action) {
  const permissions = prStatusPermissions[status];
  return permissions ? permissions[action] : { allowed: false, message: 'Invalid status or action.' };
}